<div class="document-item document-item--historic">
    <div class="document-item__status">
        <div class="tag-image tag-image--simple">
            <i class="{{ iconService.evidenceIcon(evidence.type) }}"></i>
        </div>
        <span>{{ 'AUDIT.EVIDENCES.SHORT.'  + evidence.type | translate }}</span>
    </div>
    <div class="document-item__info">
        <div class="document-item__info__text">
            <b>{{ 'AUDIT.EVIDENCES.LONG.'  + evidence.type | translate }}</b>
            <span>{{ receiver?.email }}</span>
        </div>
    </div>
    <div class="document-item__data">
        <b>{{ timeService.timestampToFormat(evidence.timestamp, 'DD/MM/YYYY') }}</b>
        <span>{{ timeService.timestampToFormat(evidence.timestamp, 'HH:mm:ss') }} (UTC)</span>
    </div>
</div>
